import React from "react";
import { Link } from "react-router-dom";
import { Mail, Heart } from "lucide-react";
import Logo from "./Logo";
import { CONTACT_EMAIL, APPLE_STORE_URL, GOOGLE_PLAY_URL } from "../lib/constants";

export const Footer = () => {
  return (
    <footer
      className="relative mt-20 border-t border-[#7c3aed]/10 bg-gradient-to-b from-white to-[#f5edff]"
      data-testid="site-footer"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-12 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <Logo />
          <p className="mt-4 text-sm text-[#3c1e6b]/70 max-w-xs leading-relaxed">
            Aplicativo brasileiro feito para reconectar pessoas que perderam
            seus pets com quem os encontrou.
          </p>
        </div>

        <div>
          <h4 className="font-display font-semibold text-[#5B21B6] mb-3">
            Navegação
          </h4>
          <ul className="space-y-2 text-sm">
            <li>
              <Link
                to="/"
                data-testid="footer-link-home"
                className="text-[#3c1e6b]/70 hover:text-[#6d28d9] transition-colors"
              >
                Início
              </Link>
            </li>
            <li>
              <Link
                to="/sobre"
                data-testid="footer-link-about"
                className="text-[#3c1e6b]/70 hover:text-[#6d28d9] transition-colors"
              >
                Sobre o app
              </Link>
            </li>
            <li>
              <a
                href={GOOGLE_PLAY_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-link-google-play"
                className="text-[#3c1e6b]/70 hover:text-[#6d28d9] transition-colors"
              >
                Baixar no Google Play
              </a>
            </li>
            <li>
              <a
                href={APPLE_STORE_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-link-apple-store"
                className="text-[#3c1e6b]/70 hover:text-[#6d28d9] transition-colors"
              >
                Baixar na App Store
              </a>
            </li>
            <li>
              <Link
                to="/privacidade"
                data-testid="footer-link-privacy"
                className="text-[#3c1e6b]/70 hover:text-[#6d28d9] transition-colors"
              >
                Política de Privacidade
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-display font-semibold text-[#5B21B6] mb-3">
            Contato
          </h4>
          <a
            href={`mailto:${CONTACT_EMAIL}`}
            data-testid="footer-contact-email"
            className="inline-flex items-center gap-2 text-sm text-[#3c1e6b]/80 hover:text-[#6d28d9] transition-colors break-all"
          >
            <Mail size={16} className="text-[#14B8A6] shrink-0" />
            {CONTACT_EMAIL}
          </a>
          <p className="mt-4 text-xs text-[#3c1e6b]/55 leading-relaxed">
            Tem dúvidas, sugestões ou histórias de reencontro? Escreva pra
            gente. Adoramos ouvir vocês.
          </p>
        </div>
      </div>

      <div className="border-t border-[#7c3aed]/10">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-xs text-[#3c1e6b]/55">
            © {new Date().getFullYear()} Pets · Perdidos e Achados. Todos os
            direitos reservados.
          </p>
          <p className="text-xs text-[#3c1e6b]/55 inline-flex items-center gap-1.5">
            Feito com{" "}
            <Heart size={12} className="text-[#7c3aed] fill-[#7c3aed]" /> para
            ajudar pets a voltarem pra casa.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
